import React from 'react';
import './Event.css';

import { Button } from '../../components';

import { FaClock } from 'react-icons/fa';
import { FaCalendarDays, FaLocationDot } from 'react-icons/fa6';

import { Link } from 'react-router-dom';



const Event = ({ event }) => {

  const { image, title } = event; // Extracting data from event object

  return (
    <div className='event-item'>

      <img src={image} alt={title} /> {/* Event image */}

      <div className='content'>

        {/* Link to event details page */}
        <Link to={`/Events/${title}`} state={event}><h3>{title}</h3></Link> {/* Event title */}

        <p>{event.content}</p>

        <div className='details'>
          <h5><div className='icon'><FaCalendarDays /></div> <span>{event.details.date}</span></h5> {/* Event Date */}
          <h5><div className='icon'><FaClock /></div> <span>{event.details.time}</span></h5> {/* Event Time */}
          <h5><div className='icon'><FaLocationDot /></div> <span>{event.details.location}</span></h5> {/* Event venue */}
        </div>

        <Button link={'Contact-us'} title={'Register Now'} />

      </div>
    </div>
  );
};

export default Event;
